const APP_SESSION_KEYS = [
  "_user_",
  "avaNumbers",
  "_consent_Tkn",
  "walletUserSess",
  "status",
  "token",
  "profile",
  "consentVerified",
  "lastConsentCheck",
  "dealerRegisterForm",
  "mnpRegisterForm",
  "topupAmount",
];

const getStorage = () => {
  if (typeof window === "undefined") return null;

  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
};

const Session = {
  get(key) {
    const storage = getStorage();
    if (!storage) return undefined;

    try {
      const value = storage.getItem(key);
      return value === null ? undefined : value;
    } catch {
      return undefined;
    }
  },

  set(key, value) {
    const storage = getStorage();
    if (!storage) return;

    try {
      if (value === undefined || value === null) {
        storage.removeItem(key);
        return;
      }

      storage.setItem(key, String(value));
    } catch {
      // Storage may be unavailable or full. Callers keep their in-memory state.
    }
  },

  remove(key) {
    const storage = getStorage();
    if (!storage) return;

    try {
      storage.removeItem(key);
    } catch {
      // Storage may be unavailable in restricted browser contexts.
    }
  },

  clear() {
    APP_SESSION_KEYS.forEach((key) => Session.remove(key));
  },
};

export default Session;
